export const DEFAULT_REMIX_ICON = "ri-question-line";

export type RemixIconSize = "xs" | "sm" | "md";

const SIZE_STYLES: Record<RemixIconSize, { wrapper: string; glyph: string }> = {
    xs: { wrapper: "size-6", glyph: "text-xs" },
    sm: { wrapper: "size-7", glyph: "text-sm" },
    md: { wrapper: "size-8", glyph: "text-sm" },
};

export interface RemixIconProps {
    icon: string | null | undefined;
    size?: RemixIconSize;
    pillColor?: string;
}

export function RemixIcon({ icon, size = "md", pillColor }: RemixIconProps) {
    const iconClass = icon || DEFAULT_REMIX_ICON;
    const { wrapper, glyph } = SIZE_STYLES[size];

    return (
        <div
            className={`${wrapper} flex shrink-0 items-center justify-center rounded-full text-gray-700`}
            style={{ backgroundColor: pillColor }}
        >
            <i className={`${iconClass} ${glyph} block leading-none`} aria-hidden="true" />
        </div>
    );
}
